import { render, staticRenderFns } from "./DateSpan.vue?vue&type=template&id=64063cc1&scoped=true&"
import script from "./DateSpan.vue?vue&type=script&lang=js&"
export * from "./DateSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64063cc1",
  null
  
)

export default component.exports